import axiosClient from "./axiosClient";

interface ConfirmRequest {
  orderNo: string;
  lastName: string;
  agencyId: string;
  amount: string;
  departureDate: string;
  postalCode: string;
}

async function confirmCancellationService(req: ConfirmRequest) {
  const bodyRequest = {
    orderNo: req.orderNo,
    lastName: req.lastName,
    agencyId: req.agencyId,
    departureDate: req.departureDate,
    amount: req.amount,
    postalCode: req.postalCode,
  };

  try {
    const response = await axiosClient.post(
      "/cancellation/confirmCancellation",
      bodyRequest,
    );
    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}

export default confirmCancellationService;
